<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="pubitCssCls1"></p>
<p class="pubitCssCls26"><span class="Apple-style-span sgc-1"> </span><br/></p>
<p class="pubitCssCls28"><span class="pubitCssCls29">Acknowlegments</span></p>
<p class="pubitCssCls30"><span class="pubitCssCls14"> </span></p>
<p class="pubitCssCls30"><span class="pubitCssCls14">Thank you to my editor Jennifer Melendrez who corrected the thousand and one punctuation errors and whose suggestions made it a far better book.</span></p>
<p class="pubitCssCls30"><span class="pubitCssCls14">Thanks to my wife Emily for making vital suggestions for the book and for tolerating my full-time retired presence while I commandeered a corner of our living room for my portable writing desk.</span></p>
<p class="pubitCssCls30"><span class="pubitCssCls14">Thank you Sunbury Press for publishing my work.</span></p>
<p class="pubitCssCls30"><span class="pubitCssCls14">And last but not least, a salute to all the millions of RVers across the country seeking adventure. I wish you smooth highways and level campsites.</span></p>
<p class="pubitCssCls30"><span class="pubitCssCls14"> </span></p>
<p class="pubitCssCls30"><span class="pubitCssCls14">             </span> <span class="pubitCssCls14">             </span> <span class="pubitCssCls14">             </span> <span class="pubitCssCls14">***********</span></p>
<p class="pubitCssCls30"><span class="pubitCssCls14"> </span></p>
<p class="pubitCssCls30"><span class="pubitCssCls31">Look for the next Hank and Helen Moran RV adventure. Book two of the RV Mysteries is in progress and will be published in the spring of 2012.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?49466908